
  export default {
    name: "UserIcon",
    props: {
      fill: {
        default: '#000000'
      }
    }
  }
